import GlobalStateContext from "contexts/GlobalStateContext";
import { useContext } from "react";

export default function useDeleteConfirmationModal() {
  const { state, setState: updateGlobalState } = useContext(GlobalStateContext);

  const setState = (args) => {
    const newState = { ...state.deleteConfirmationModalState, ...args };
    updateGlobalState({ deleteConfirmationModalState: newState });
  };

  return {
    close: () => setState({ isOpen: false }),
    data: state.deleteConfirmationModalState.data,
    isOpen: state.deleteConfirmationModalState.isOpen,
    open: (data) => setState({ data, isOpen: true }),
  };
}
